"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgFamily = function SvgFamily(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10.98 30.453s0-1.233.771-1.233c.772 0 .804 1.233.804 1.233l1.897 17.327S14.664 50 16.984 50s1.371-2.22 1.371-2.22l-1.69-25.044s-.975-1.016-.521-2.188c.188-.352.535-.59.982-.548.7.067 1.547.596 1.681.697.11.082 2.087 1.88 4.577 3.416.848.523 2.28.834 2.28.834L17.243 14.81S15.28 13 12.555 13H8.884c-3.113 0-4.74 1.912-4.655 6.169.085 4.257-.949 13.171-.949 13.171s-.98 2.655 1.472 2.655c2.453 0 2.266-1.95 2.266-1.95v-12.27 26.752S6.112 49.993 8.406 50c2.573 0 2.407-2.045 2.407-2.045l.166-17.502Z",
    stroke: "#919499",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M11 12a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z",
    stroke: "#919499"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M47.356 32.015c.304 2.11.729 4.046.729 4.046H37.096h7.278v11.497S45.544 50 43.528 50c-2.017 0-2.224-2.081-2.224-2.081V36.061h-1.288l-.045 11.858s-.244 2.068-2.147 2.08c-1.904.014-.728-2.44-.728-2.44V36.06h-3.683l2.23-17.855-4.703 7.983s-1.244-1.06-2.94-1.34c.416-.727.806-1.342 1.185-2.01 3.015-1.153 2.85-3.48 2.762-4.789a50.669 50.669 0 0 1 1.96-2.937c2.095-2.902 7.01-3.109 7.01-3.109s5.107-.128 6.127 3.81c1.02 3.938 1.361 11.868 1.361 11.868s1.496 3.366-.77 4.2c-2.267.832-2.399-3.037-2.399-3.037l-.703-10.18.703 10.18s.148 3.589 2.12 3.17Z",
    stroke: "#919499",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M41 11a5 5 0 1 0 0-10 5 5 0 0 0 0 10ZM28 23a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
    stroke: "#919499"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m25.593 37.878-.962 10.63S25.247 51 23.567 51c-1.681 0-1.492-2.492-1.492-2.492l.961-12.25v-8.705l-5.692-4.26s-1.718-1.193-1.24-2.593c.477-1.4 2.708 0 2.708 0s3.305 2.734 4.755 3.518c1.45.785 3.304.916 3.304.916s4.047.478 4.458 2.893c.412 2.416.412 7.816.412 7.816s.886 3.93-1.258 3.93c-1.643 0-1.493-10.05-1.493-10.05v10.05l.487 8.735S30.408 51 28.76 51c-1.648 0-1.726-1.686-1.726-1.686l-.711-11.436h-.73Z",
    stroke: "#919499",
    strokeLinejoin: "round"
  }));
};

var Memo = /*#__PURE__*/(0, React.memo)(SvgFamily);
var _default = Memo;
exports["default"] = _default;